import { Button, Dialog, Stack } from '@sixui/ui';
import stylex from '@stylexjs/stylex';
import { useTranslation } from 'react-i18next';

import { ArticleListItemCopyShareLinkDialogForm } from './ArticleListItemCopyShareLinkDialogForm';

export type IArticleListItemCopyShareLinkDialogProps = {
  opened: boolean;
  onClose: () => void;
  getShareUrl: () => Promise<string | null>;
};

const styles = stylex.create({
  dialog: {
    width: 480,
  },
});

export const ArticleListItemCopyShareLinkDialog: React.FC<
  IArticleListItemCopyShareLinkDialogProps
> = (props) => {
  const { opened, onClose, getShareUrl } = props;
  const { t } = useTranslation();

  return (
    <Dialog
      sx={[styles.dialog]}
      actions={({ close }) => (
        <>
          <Button variant="text" onClick={close}>
            {t('ArticleListItemCopyShareLinkDialog.close')}
          </Button>
        </>
      )}
      opened={opened}
      onClose={onClose}
      headline={
        <Stack gap={1} align="center">
          <div>{t('ArticleListItemCopyShareLinkDialog.title')}</div>
        </Stack>
      }
    >
      <ArticleListItemCopyShareLinkDialogForm getShareUrl={getShareUrl} />
    </Dialog>
  );
};
